import { ModelSagres } from "../../model-sagres";

export class HistoricoLicitacao extends ModelSagres {
  NmUsuarioUltimaAlteracao: string;
  TipoLog: string;
  DtLog: Date;

  tratarDadosDaAPI(): void {
    if (this.DtLog) {
      this.DtLog = new Date(this.DtLog);
    }
    if (this.TipoLog) {
      switch (this.TipoLog) {
        case "I":
          this.TipoLog = "Inclusão";
          break;
        case "U":
          this.TipoLog = "Alteração";
          break;
        case "D":
          this.TipoLog = "Exclusão";
          break;
      }
    }
  }
}
